import React from 'react';
import { Leaf } from 'lucide-react';
export function ProductPresentation() {
  return <section className="bg-blanco py-16 md:py-24 px-4 border-t border-marron/10" data-id="element-267">
      <div className="max-w-4xl mx-auto text-center" data-id="element-268">
        <div className="flex justify-center mb-6" data-id="element-269">
          <div className="bg-verde/10 p-4 rounded-full" data-id="element-270">
            <Leaf className="w-12 h-12 text-verde" data-id="element-271" />
          </div>
        </div>

        <h3 className="text-sm md:text-base font-montserrat font-bold text-verde tracking-[0.2em] uppercase mb-4" data-id="element-272">
          🌿 Presentando el Sistema Completo
        </h3>

        <h2 className="text-[32px] md:text-[56px] font-playfair font-bold text-marron leading-tight mb-6" data-id="element-273">
          ALIMENTACIÓN ANTIENVEJECIMIENTO:
          <br data-id="element-274" />
          <span className="text-terracota" data-id="element-275">EL COLÁGENO NATURAL</span>
        </h2>

        <p className="text-xl md:text-2xl text-carbon font-inter italic max-w-3xl mx-auto" data-id="element-276">
          El protocolo de Bio-Síntesis 3™ con 15 recetas completas + 6
          colaciones de regalo que convierten tu cocina en la fábrica de
          colágeno más poderosa de tu cuerpo.
        </p>
      </div>
    </section>;
}